/**
 * @file common.ts
 * @author Rapoo Device SDK Team
 * @date 2026-06-11
 * @description OHID系列设备通用方法
 */

/**
 * 计算校验和
 */
export function calculateChecksum(view: DataView, dataLength: number, dataStart: number): number {
  let checksum = 0

  // 头部 + 1
  checksum += view.getUint8(0) + 1
  // 长度 + 2
  checksum += dataLength + 2
  // 命令 + 3
  checksum += view.getUint8(2) + 3

  // 数据部分
  if (dataLength > 0) {
    for (let i = 0; i < dataLength; i++) {
      checksum += view.getUint8(dataStart + i) + i + 4
    }
  }

  return checksum & 0xff
}
